import React, { useState, useEffect } from "react";
import "./Navbar.scss";
import { useNavigate, useLocation } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import StarIcon from "@mui/icons-material/Star";
import LogoutImage from "../../Resources/Images/LogoutImg.png";
import LockIcon from "../../Resources/Images/navpass.png";
import ExitToAppIcon from "../../Resources/Images/navlogout.png";
import ChangePasswordModal from "./ChangePasswordModal";

import {
  AdminMenu,
  BranchManagerMenu,
  OperatorMenu,
  UserMenu,
  PTStaffMenu,
  SubCodeMenu,
  menuForUser,
} from "./Menu";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Tooltip from "@mui/material/Tooltip";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Drawer from "@mui/material/Drawer";
import Profile from "../Profile/Profile";
import SettingsIcon from "@mui/icons-material/Settings";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import JoinInnerIcon from "@mui/icons-material/JoinInner";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { ToastContainer, toast } from "react-toastify";
import MenuIcon from "@mui/icons-material/Menu";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Notification from "../Notification/Notification";
import NotificationBell from "../Notification/NotificationBell";
import RealtimeBridge from "../Realtime/RealtimeBridge";
import { disconnectRealtime } from "../../Service/realtime";
import { useQrQueue } from "../Realtime/qrQueue";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { currentBrand } from "../Policy/OnlinePolicy/utils/brand";
import BrandRibbon from "./BrandRibbon";
import LogoText from "../../Resources/Images/Logo-Text.png";
import {
  KeyboardArrowDownIcon,
  ArrowForwardIosIcon,
  AddIcon,
  KeyboardArrowUpIcon,
} from "../../Resources/Icons/icons";
import ConfirmBox from "../../UiComponents/ConfirmBox/ConfirmBox";
import LogoutIcon from "@mui/icons-material/Logout";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import Button from "@mui/material/Button";
import { getLabelForValue } from "../../Shared/CommonConstant";
import AddUserConfig from "../Configuration/UserConfig/AddUserConfig";
import { GetUserConfigById } from "../../Service/UserConfigService";
import { GetUserFindbyId } from "../../Service/UserService";
import AddUser from "../User/AddUser";
import { Divider, Stack, useMediaQuery, useTheme } from "@mui/material";
import { Logout } from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
import DnsRoundedIcon from "@mui/icons-material/DnsRounded";
import { GetUser } from "../../Service/UserService";

const Navbar = ({ children }) => {
  const navigate = useNavigate();
  let location = useLocation();
  const [dropDown, setDropDown] = useState();
  const [openProfileDrawer, setOpenProfileDrawer] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [openCalendar, setOpenCalandar] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  // the phone drawer: which third-level group (a sub-page that has its own pages) is open, by title
  const [mobileSubOpen, setMobileSubOpen] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [subNavDropDown, setSubNavDropDown] = useState();
  const [openSubNavDropDown, setOpenSubNavDropDown] = useState(false);
  const [UserName, setUserName] = React.useState("");
  const [Email, setEmail] = React.useState("");
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [subMenuPos, setSubMenuPos] = useState({ top: 0, left: 0, parentLeft: 0 });
  const subMenuRef = React.useRef(null);
  const [formType, setFormType] = useState("");
  const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);
  const [userData, setUserData] = React.useState({});
  const theme = useTheme();
  const isScreenMdOrLarger = useMediaQuery(theme.breakpoints.up("md"));
  // Rayal or Agaram, by the domain the app is opened on (the same rule as the tab title, the login page and the PDF).
  const brand = currentBrand();
  const [openLoader, setOpenLoader] = useState(false);
  const [user, setUser] = React.useState([]);

  const Active = (menu) => { };

  const [contextMenu, setContextMenu] = useState(null);
  const [path, setPath] = useState(null);

  const subDropDown = (e, item) => {
    const rect = e.currentTarget.getBoundingClientRect();
    if (rect) {
      setSubMenuPos({ top: rect.top, left: rect.right, parentLeft: rect.left });
    }
    setPath(item.path);
    setSubNavDropDown(item);
    setOpenSubNavDropDown(true);
  };

  // The menu inside a menu is pinned to the screen at its parent item. On a short or narrow window that put its lower part
  // (or its right side) off the screen: lift it so it fits, open it to the left of its parent when there is no room on the
  // right, and let it scroll (.ThirdHeaderSubMenu has a max-height) when it is still taller than the window.
  React.useLayoutEffect(() => {
    const el = subMenuRef.current;
    if (!openSubNavDropDown || !el) return;
    const margin = 8;
    el.style.left = "0px"; // measured at the left edge: a fixed box near the right edge is squeezed to the room left of it
    const { offsetHeight: h, offsetWidth: w } = el;
    const vh = window.innerHeight;
    const vw = window.innerWidth;
    el.style.top = `${Math.max(margin, Math.min(subMenuPos.top, vh - h - margin))}px`;
    const fitsRight = subMenuPos.left + w + margin <= vw;
    el.style.left = `${fitsRight ? subMenuPos.left : Math.max(margin, subMenuPos.parentLeft - w)}px`;
  }, [openSubNavDropDown, subNavDropDown, subMenuPos]);

  const Routing = (item) => {
    if (location.pathname === item.path) {
      window.location.reload(false);
    } else {
      navigate(item.path);
      setMobileOpen(false);
      setOpenDropdown(false);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };

  const navigateSubNav = (e) => {
    if (location.pathname === e) {
      window.location.reload(false);
    } else {
      navigate(e);
      setOpenSubNavDropDown(false);
      setOpenDropdown(false);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };

  // The desktop menu row scrolls sideways when it does not fit (arrows at its ends). Its first dropdown is drawn
  // pinned to the screen at the button's place, so the scrolling row cannot cut it off.
  const navRowRef = React.useRef(null);
  const [navDropPos, setNavDropPos] = useState({ top: 58, left: 0 });
  const [navCanScroll, setNavCanScroll] = useState({ left: false, right: false });
  const updateNavScroll = React.useCallback(() => {
    const el = navRowRef.current;
    if (!el) return;
    const left = el.scrollLeft > 2;
    const right = el.scrollLeft + el.clientWidth < el.scrollWidth - 2;
    setNavCanScroll((was) => (was.left === left && was.right === right ? was : { left, right }));
  }, []);
  useEffect(() => {
    updateNavScroll();
    window.addEventListener("resize", updateNavScroll);
    return () => window.removeEventListener("resize", updateNavScroll);
  }, [updateNavScroll]);
  const scrollNavRow = (direction) => {
    const el = navRowRef.current;
    if (el) el.scrollBy({ left: direction * Math.max(160, el.clientWidth * 0.6), behavior: "smooth" });
  };

  const handleOpenUserMenu = (menu) => {
    setDropDown(menu);
    setOpenDropdown(true);
    setOpenSubNavDropDown(false);
  };
  const MobileOpenUserMenu = (menu) => {
    setDropDown(menu);
  };

  const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  }));

  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      expandIcon={
        <ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem", color: "red" }} />
      }
      {...props}
    />
  ))(({ theme }) => ({
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, .05)"
        : "rgba(0, 0, 0, .03)",
    flexDirection: "row-reverse",
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      transform: "rotate(0deg)",
    },
    "& .MuiAccordionSummary-content": {
      marginLeft: theme.spacing(1),
    },
  }));

  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, .125)",
  }));

  const [contextOn, setContextOn] = useState(false);
  const menuRef = React.useRef(null);
  const handleContextMenu = (event, menu) => {
    event.preventDefault();
    setContextMenu({
      left: event.clientX,
      top: event.clientY,
    });
    setOpenDropdown(true);
    setContextOn(true);
  };

  const handleSubContextMenu = (event) => {
    event.preventDefault();
    setContextMenu({
      left: event.clientX,
      top: event.clientY,
    });
  };

  const handleCloseContextMenu = () => {
    setContextMenu(null);
    setOpenDropdown(false);
    setContextOn(false);
  };

  const HandleOpenNewLink = () => {
    window.open(`${path}`, "_blank");
    handleCloseContextMenu();
  };

  const HandleSaveThePage = (e) => {
    const saveEvent = new KeyboardEvent("keydown", {
      key: "s",
      ctrlKey: true,
      bubbles: true,
      cancelable: true,
    });
  };

  const handleMouseLeave = (e) => {
    if (contextOn) {
      setOpenDropdown(true);
    } else {
      setOpenDropdown(false);
    }
  };


  const handleViewProfile = () => {
    setOpenProfile(false);
    const UserId = sessionStorage.getItem("UserId");
    GetUserFindbyId(UserId).then((res) => {
      setOpenProfileDrawer(true);
      setFormType("edit");
      setUserData(res.data);
    });
  };

  // Changes by Arun
  const getUserData = () => {
    if (UserType === "CLIENT" || UserType === "user" || UserType === "ptstaff" || UserType === "branchManager" || UserType === "operator") {
      setOpenProfile(true);
    } else {
      const UserId = sessionStorage.getItem("UserId");
      GetUserFindbyId(UserId).then((res) => {
        setOpenProfileDrawer(true);
        setFormType("edit");
        setUserData(res.data);
      });
    }
  };

  const GetData = () => {
    const requesttype = "TABLE";
    setOpenLoader(true);
    GetUser({ isAscending: false, requesttype }).then((res) => {
      setOpenLoader(false);
      const modifiedUserData = res?.data.map((e) => {
        return {
          ...e,
          branchManager: e?.branchManager?.branchId?.branchName,
        };
      });
      setUser(modifiedUserData);
    });
  };
  React.useEffect(() => {
    GetData();
  }, []);

  useEffect(() => {
    const GetUserName = sessionStorage.getItem("name");
    const GetEmail = sessionStorage.getItem("email");
    if (GetUserName) {
      setUserName(GetUserName);
    }
    if (GetEmail) {
      setEmail(GetEmail);
    }
  }, []);

  useEffect(() => {
    if (isScreenMdOrLarger) {
      setMobileOpen(false);
    }
  }, [isScreenMdOrLarger]);

  const LogoutFunction = () => {
    // live policy updates: the next login must not hear this one's messages
    disconnectRealtime();
    useQrQueue.getState().clear();
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("name");
    sessionStorage.removeItem("UserId");
    sessionStorage.removeItem("clientID");
    sessionStorage.removeItem("userType");
    navigate("/");
  };
  const UserType = sessionStorage.getItem("userType");
  let Menus;
  if (UserType === "CLIENT") {
    Menus = AdminMenu;
  } else if (UserType === "branchManager") {
    Menus = BranchManagerMenu;
  } else if (UserType === "operator") {
    Menus = OperatorMenu;
  } else if (UserType === "accountant") {
    Menus = AdminMenu;
  } else if (UserType === "user") {
    Menus = UserMenu;
  } else if (UserType === "ptstaff") {
    Menus = PTStaffMenu;
  } else if (UserType === "SUBCODE") {
    Menus = SubCodeMenu;
  } else {
    Menus = [];
  }
  // One filter feeds both the desktop bar and the mobile drawer.
  Menus = menuForUser(Menus, UserType, sessionStorage.getItem("roleId"));

  // The page's name for the phone top bar: the menu entry for this address (a sub-page first), else the app's name.
  const mobilePageTitle = (() => {
    const here = String(location.pathname || "").toLowerCase();
    const entries = [];
    for (const item of Menus || []) {
      for (const sub of item.subMenu || []) if (sub && sub.path) entries.push(sub);
      if (item && item.path) entries.push(item);
    }
    const exact = entries.find((e) => String(e.path).toLowerCase() === here);
    if (exact) return exact.title;
    const prefix = entries
      .filter((e) => e.path && e.path !== "/" && here.startsWith(String(e.path).toLowerCase() + "/"))
      .sort((a, b) => String(b.path).length - String(a.path).length)[0];
    if (prefix) return prefix.title;
    if (here.startsWith("/servercontrol")) return "Server Control";
    return brand.name;
  })();

  return (
    <>
      <div className="MainPage" onClick={handleCloseContextMenu}>
        <AppBar component="nav" className="MainAppBar">
          <Toolbar className="Top_Navbar_Second">
            <Box
              sx={{
                // background: "#000",
                display: { xs: "flex", md: "none", xl: "none" },
                alignItems: "center",
                gap: 1.5,
                minWidth: 0,
              }}>
              <BrandRibbon brand={brand} phone>
                <img src={brand.navLogoUrl} alt={brand.name} data-testid="navbar-logo-phone" />
              </BrandRibbon>
              <button
                type="button"
                aria-label="Open menu"
                data-testid="MenuIcon"
                className={`NavMenuButton NavBrand--${brand.key}`}
                onClick={() => setMobileOpen(!mobileOpen)}>
                <i />
                <i />
              </button>
              {/* phones: the page's name next to the menu button (the bar was empty there) */}
              <Typography
                noWrap
                data-testid="mobile-page-title"
                sx={{
                  color: "#fff",
                  fontFamily: "Inter, Poppins, sans-serif",
                  fontWeight: 700,
                  fontSize: "16px",
                  maxWidth: "52vw",
                }}>
                {mobilePageTitle}
              </Typography>
            </Box>

            {/* outside the scrolling menu row, so it stays at the left when the menu scrolls */}
            <BrandRibbon brand={brand} sx={{ display: { xs: "none", md: "flex" } }}>
              <img src={brand.navLogoUrl} alt={brand.name} data-testid="navbar-logo" />
            </BrandRibbon>

            <Box
              className={`NavScrollWrap${navCanScroll.left ? " has-left" : ""}${navCanScroll.right ? " has-right" : ""}`}
              sx={{
                position: "relative",
                flex: 1,
                minWidth: 0,
                display: { xs: "none", md: "flex", xl: "flex" },
              }}>
            {navCanScroll.left ? (
              <IconButton aria-label="Scroll the menu left" className="NavScrollArrow NavScrollArrow--left" onClick={() => scrollNavRow(-1)}>
                <ArrowBackIosNewRoundedIcon sx={{ fontSize: 16 }} />
              </IconButton>
            ) : null}
            <Box
              ref={navRowRef}
              onScroll={updateNavScroll}
              className="NavScrollRow"
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                pointerEvents: contextMenu ? "none" : "auto",
              }}>
              {Menus.map((menu, i) => {
                const uniqueId = "Header" + i;
                if (menu.subMenu && menu.subMenu.length) {
                  return (
                    <React.Fragment key={uniqueId}>
                      <button
                        onMouseEnter={(e) => {
                          const rect = e.currentTarget.getBoundingClientRect();
                          setNavDropPos({ top: rect.top + 58, left: rect.left });
                          handleOpenUserMenu(menu);
                        }}
                        onMouseLeave={(e) => handleMouseLeave(e)}
                        onContextMenu={(e) => handleContextMenu(e, menu)}
                        className={
                          "NavHeading " + (Active(menu) ? "Active" : "")
                        }
                        style={{ position: "relative" }}>
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                          }}
                          className="menu-item">
                          <div
                            style={{ paddingTop: "4px" }}
                            className="menu-icon">
                            {menu.icon}
                          </div>
                          <div
                            style={{
                              paddingTop: "6px",
                              fontWeight: 400,
                              fontSize: "12px",
                              color: "white",
                            }}
                            className="menu-title">
                            <div
                              className="menu-title"
                              style={{
                                fontSize: "14px",
                              }}>
                              {menu.title}
                            </div>
                          </div>
                        </div>
                        {openDropdown ? (
                          <div
                            style={{
                              position: "fixed",
                              left: navDropPos.left,
                              top: navDropPos.top,
                            }}
                            className="NavbarDropDown">
                            {dropDown?.subMenu?.map((subMenu, i) => {
                              const secondSunNavId = "secondSubNav" + i;
                              if (menu.parent === subMenu.child) {
                                return (
                                  <React.Fragment key={secondSunNavId}>
                                    <div className="ThirdHeaderMenu">
                                      <h1
                                        onClick={() => Routing(subMenu)}
                                        onMouseEnter={(e) =>
                                          subDropDown(e, subMenu)
                                        }>
                                        <div className="ThirdHeaderMenu-text">
                                          {subMenu.title}
                                        </div>
                                        <div
                                          style={{
                                            paddingRight: "10px",
                                          }}>
                                          {subMenu.path === "/#" ? (
                                            <ArrowForwardIosIcon
                                              sx={{ fontSize: "15px" }}
                                            />
                                          ) : null}
                                        </div>
                                      </h1>
                                      {openSubNavDropDown &&
                                        subMenu.subOrder === subNavDropDown?.subOrder ? (
                                        <div
                                          className="ThirdHeaderSubMenu"
                                          ref={subMenuRef}
                                          style={{
                                            position: "fixed",
                                            top: subMenuPos.top,
                                            left: subMenuPos.left,
                                          }}>
                                          {subMenu?.subMenu?.map((e, i) => {
                                            const thirdSubNavId =
                                              "thirdSubNav" + i;
                                            if (
                                              e.subChild ===
                                              subNavDropDown?.subOrder
                                            ) {
                                              return (
                                                <h1
                                                  className="ThirdHeaderMenu-text"
                                                  key={thirdSubNavId}
                                                  onClick={() =>
                                                    navigateSubNav(e.path)
                                                  }
                                                  onMouseEnter={() =>
                                                    setPath(e.path)
                                                  }>
                                                  {e.title}
                                                </h1>
                                              );
                                            } else return null;
                                          })}
                                        </div>
                                      ) : null}
                                    </div>
                                  </React.Fragment>
                                );
                              }
                            })}
                          </div>
                        ) : null}
                      </button>
                    </React.Fragment>
                  );
                } else {
                  return (
                    <button
                      onClick={() => Routing(menu)}
                      onMouseEnter={() => setPath(menu.path)}
                      onContextMenu={(e) => handleSubContextMenu(e, menu)}
                      className={"NavHeading " + (Active(menu) ? "Active" : "")}
                      key={uniqueId}>
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          alignItems: "center",
                        }}
                        className="menu-item">
                        <div
                          style={{ paddingTop: "4px" }}
                          className="menu-icon">
                          {menu.icon}
                        </div>
                        <div
                          style={{
                            paddingTop: "6px",
                            fontWeight: 400,
                            fontSize: "12px",
                            color: "white",
                          }}
                          className="menu-title">
                          <div
                            style={{ fontSize: "14px" }}
                            className="menu-title">
                            {menu.title}
                          </div>
                        </div>
                      </div>
                    </button>
                  );
                }
              })}
            </Box>
            {navCanScroll.right ? (
              <IconButton aria-label="Scroll the menu right" className="NavScrollArrow NavScrollArrow--right" onClick={() => scrollNavRow(1)}>
                <ArrowForwardIosRoundedIcon sx={{ fontSize: 16 }} />
              </IconButton>
            ) : null}
            </Box>

            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{
                width: "1px",
                height: "70%",
                display: { xs: "none", md: "flex", xl: "flex" },
                backgroundColor: "#64748B",
              }}
            />
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <NotificationBell />
              <RealtimeBridge />
              <Typography sx={{ color: "#393939", fontFamily: "Poppins" }}>
                <Menu
                  sx={{ mt: "42px" }}
                  id="menu-appbar"
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={openProfile}
                  onClose={() => setOpenProfile(false)}
                  PaperProps={{ className: "ProfileMenu" }}>
                  <Box className="ProfileMenu__body">
                    <Box className="ProfileMenu__head">
                      <Box className="avatar-container">
                        <Avatar
                          alt={UserName}
                          className="gold-avatar"
                          sx={{ borderRadius: "50px" }}
                          src="React Js"
                        />
                        <StarIcon className="avatar-star" />
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
                        <Typography noWrap className="ProfileMenu__name">
                          {UserName}
                        </Typography>
                        <Typography noWrap className="ProfileMenu__email">
                          {Email}
                        </Typography>
                      </Box>
                    </Box>



                    {/* No profile for the super admin (2026-10-22) - he is not a broker with portal logins or wallets */}
                    {sessionStorage.getItem("roleId") !== "SUPER_ADMIN" && (
                    <Box
                      className="ProfileMenu__item"
                      onClick={() => handleViewProfile()}>
                      <span className="ProfileMenu__icon">
                        <PersonIcon />
                      </span>
                      <Typography className="ProfileMenu__label">
                        View Profile
                      </Typography>
                    </Box>
                    )}

                    <Box
                      className="ProfileMenu__item"
                      onClick={() => setOpenChangePasswordModal(true)}>
                      <span className="ProfileMenu__icon">
                        <img src={LockIcon} alt="" style={{ width: "18px", height: "16px" }} />
                      </span>
                      <Typography className="ProfileMenu__label">
                        Change Password
                      </Typography>
                    </Box>

                    {/* Server Control — the super admin only (the page itself refuses anyone else too) */}
                    {sessionStorage.getItem("roleId") === "SUPER_ADMIN" && (
                      <Box
                        data-testid="profile-server-control"
                        className="ProfileMenu__item"
                        onClick={() => {
                          setOpenProfile(false);
                          navigate("/serverControl");
                        }}>
                        <span className="ProfileMenu__icon">
                          <DnsRoundedIcon />
                        </span>
                        <Typography className="ProfileMenu__label">
                          Server Control
                        </Typography>
                      </Box>
                    )}

                    <Box
                      className="ProfileMenu__item is-danger"
                      onClick={() => setOpenConfirmBox(true)}>
                      <span className="ProfileMenu__icon">
                        <img src={ExitToAppIcon} alt="" style={{ width: "16px", height: "16px" }} />
                      </span>
                      <Typography className="ProfileMenu__label">
                        Logout
                      </Typography>
                    </Box>
                  </Box>
                </Menu>
              </Typography>
              <Tooltip title="Profile">
                <IconButton sx={{ p: 0 }} onClick={() => getUserData()}>
                  <Box className="avatar-container">
                    <Avatar
                      alt={UserName}
                      className="gold-avatar"
                      sx={{ borderRadius: "50px" }}
                      src="React Js"
                    />
                    <StarIcon className="avatar-star" />
                  </Box>
                </IconButton>
              </Tooltip>
            </Stack>
          </Toolbar>
          <Box
            // component="nav"
            sx={{
              flexGrow: 1,
              display: { xs: "flex", sm: "none", xl: "none" },
            }}>
            {/* <Box sx={{
              color: "#000",
              height:"100px"
            }}>
              <MenuIcon color="#000" onClick={() => setMobileOpen(!mobileOpen)} />
            </Box> */}
            <Drawer
              open={mobileOpen}
              onClose={() => setMobileOpen(false)}
              zIndex={1200}
              PaperProps={{
                className: "MobileNavDrawer",
                sx: { width: { xs: "86%", sm: 340 }, maxWidth: 360, borderRadius: "0 16px 16px 0", overflow: "hidden" },
              }}>
              {/* the new look (2026-10-19): navy header with the logo, icon tiles, the current page highlighted */}
              <Box className="MobileNavDrawer__head">
                <Box className="MobileNavDrawer__brand">
                  <img src={brand.navLogoUrl} alt={brand.name} className="MobileNavDrawer__logo" />
                  <Typography className="MobileNavDrawer__title">{brand.name}</Typography>
                </Box>
                <IconButton aria-label="Close menu" className="MobileNavDrawer__close" onClick={() => setMobileOpen(!mobileOpen)}>
                  <CloseOutlinedIcon />
                </IconButton>
              </Box>

              <Box className="MobileNavDrawer__list">
                {Menus.map((menu, i) => {
                  const uniqueId = "Header" + i;
                  const hasSub = !!(menu.subMenu && menu.subMenu.length);
                  // by title: the menu list is rebuilt on every render, so the stored entry is never the same object
                  const open = hasSub && !!dropDown && dropDown.title === menu.title;
                  // the same filters as the desktop menu: a group's own pages, and a sub-page's own pages
                  const subsOf = (m) => (m.subMenu || []).filter((sub) => m.parent === sub.child);
                  const thirdOf = (sub) => (sub.subMenu || []).filter((t) => t.subChild === sub.subOrder);
                  const here =
                    location.pathname === menu.path ||
                    (hasSub &&
                      subsOf(menu).some(
                        (sub) =>
                          (sub.path && location.pathname === sub.path) ||
                          thirdOf(sub).some((t) => t.path && location.pathname === t.path)
                      ));
                  return (
                    <Box key={uniqueId} className="MobileNavDrawer__group">
                      <Box
                        component="button"
                        type="button"
                        className={`MobileNavDrawer__item${here ? " is-active" : ""}${open ? " is-open" : ""}`}
                        onClick={() =>
                          hasSub ? (open ? setDropDown(undefined) : MobileOpenUserMenu(menu)) : Routing(menu)
                        }>
                        <span className="MobileNavDrawer__icon">{menu.icon}</span>
                        <span className="MobileNavDrawer__label">{menu.title}</span>
                        {hasSub ? <KeyboardArrowDownIcon className="MobileNavDrawer__chevron" /> : null}
                      </Box>
                      {open ? (
                        <Box className="MobileNavDrawer__sub">
                          {subsOf(menu).map((subMenu, j) => {
                            const third = thirdOf(subMenu);
                            if (!third.length) {
                              return (
                                <Box
                                  component="button"
                                  type="button"
                                  key={"secondSubNav" + i + "-" + j}
                                  className={`MobileNavDrawer__subitem${location.pathname === subMenu.path ? " is-active" : ""}`}
                                  onClick={() => Routing(subMenu)}>
                                  <span className="MobileNavDrawer__dot" />
                                  <span className="MobileNavDrawer__label">{subMenu.title}</span>
                                </Box>
                              );
                            }
                            // a sub-page with pages of its own: it opens a third list (the desktop shows it on hover)
                            const thirdOpen = mobileSubOpen === subMenu.title;
                            const thirdHere = third.some((t) => location.pathname === t.path);
                            return (
                              <Box key={"secondSubNav" + i + "-" + j}>
                                <Box
                                  component="button"
                                  type="button"
                                  className={`MobileNavDrawer__subitem${thirdHere ? " is-here" : ""}${thirdOpen ? " is-open" : ""}`}
                                  onClick={() => setMobileSubOpen(thirdOpen ? null : subMenu.title)}>
                                  <span className="MobileNavDrawer__dot" />
                                  <span className="MobileNavDrawer__label">{subMenu.title}</span>
                                  <KeyboardArrowDownIcon className="MobileNavDrawer__chevron" />
                                </Box>
                                {thirdOpen ? (
                                  <Box className="MobileNavDrawer__sub MobileNavDrawer__sub--third">
                                    {third.map((t, k) => (
                                      <Box
                                        component="button"
                                        type="button"
                                        key={"thirdSubNav" + i + "-" + j + "-" + k}
                                        className={`MobileNavDrawer__subitem${location.pathname === t.path ? " is-active" : ""}`}
                                        onClick={() => {
                                          navigateSubNav(t.path);
                                          setMobileOpen(false);
                                        }}>
                                        <span className="MobileNavDrawer__label">{t.title}</span>
                                      </Box>
                                    ))}
                                  </Box>
                                ) : null}
                              </Box>
                            );
                          })}
                        </Box>
                      ) : null}
                    </Box>
                  );
                })}
              </Box>

              <Box className="MobileNavDrawer__foot">
                <Box component="button" type="button" className="MobileNavDrawer__logout" onClick={() => navigate("/login")}>
                  Log out
                </Box>
              </Box>
            </Drawer>
          </Box>
        </AppBar>
        <ChangePasswordModal
          open={openChangePasswordModal}
          onClose={() => setOpenChangePasswordModal(false)}
        />
        <div className="renderingContainer">{children}</div>
      </div>
      {/* profile Page Drawer */}
      {setOpenProfileDrawer ? (
        <Drawer
          open={openProfileDrawer}
          onClose={() => setOpenProfileDrawer(false)}
          PaperProps={{
            // sx: { width: { md: "26%", xs: "100%" } },
            sx: { width: { xs: "100%", sm: "100%" } },
          }}
          sx={{
            zIndex: 100,
          }}
          anchor="right">
          {/* <Profile setOpenProfileDrawer={setOpenProfileDrawer} /> */}
          {/* Changed by Arun */}
          <AddUser
            setOpenDrawer={setOpenProfileDrawer}
            selectedData={userData}
            title="Update"
            GetData={GetData}
            formType={formType}
            source="Profile"

          />
        </Drawer>
      ) : null}
      {contextMenu && (
        <div
          className="Inspect_Box"
          style={{
            position: "fixed",
            left: contextMenu.left,
            top: contextMenu.top,
            zIndex: 100000,
            color: "black",
          }}>
          <ul>
            <li>
              <div onClick={HandleOpenNewLink}>Open Link in New tap</div>
            </li>
            <li>
              <div onClick={HandleOpenNewLink}>Open Link in New Window</div>
            </li>
            <li>
              <div onClick={HandleOpenNewLink}>Open Link in Incognito mode</div>
            </li>
            <li>
              <div onClick={(e) => HandleSaveThePage(e)}>Save Link as</div>
            </li>
            <hr />
            <li>
              <div onClick={HandleOpenNewLink}>Copy Link address</div>
            </li>
            <li>
              <div onClick={HandleOpenNewLink}>Open in reading Mode</div>
            </li>
            <li>
              <div onClick={HandleOpenNewLink}>Inspect</div>
            </li>
          </ul>
        </div>
      )}
      <ToastContainer position="top-right" limit={5} />
      {openConfirmBox ? (
        <ConfirmBox
          open={openConfirmBox}
          title={"Logout"}
          content={"Are you sure you want to Logout ?"}
          subContent="Unsaved progress may be lost. You can log in again anytime."
          confirmButton={"Logout"}
          img={LogoutImage}
          setOpenConfirmBox={setOpenConfirmBox}
          Function={LogoutFunction}
          icon={<LogoutIcon />}
        />
      ) : null}
    </>
  );
};

export default Navbar;
//   ....   Lamynaals Technologies ....     //

{
  // <Box
  //   // component="nav"
  //   sx={{
  //     flexGrow: 1,
  //     display: { xs: "block", sm: "none", xl: "none" },
  //   }}
  // >
  //   <MenuIcon onClick={() => setMobileOpen(!mobileOpen)} />
  //   <Drawer
  //     open={mobileOpen}
  //     onClose={() => setMobileOpen(false)}
  //     zIndex={1200}
  //     PaperProps={{
  //       sx: { width: "100%" },
  //     }}
  //   >
  //     <Typography
  //       className="d-flex justify-content-center"
  //       sx={{
  //         color: "#313949",
  //         fontWeight: 600,
  //         fontSize: "28px",
  //       }}
  //     >
  //       Rayal Brokers Insurance
  //     </Typography>
  //     <Box className="MobileResponsiveBox">
  //       <Accordion
  //         sx={{
  //           width: "100%",
  //           backgroundColor: "#313949",
  //           color: "white",
  //         }}
  //       >
  //         <AccordionSummary expandIcon={false}>
  //           <Typography sx={{ width: "100%" }} textAlign={"center"}>
  //             CRM
  //           </Typography>
  //         </AccordionSummary>
  //       </Accordion>
  //       {Menus.map((menu, i) => {
  //         const uniqueId = "Header" + i
  //         if (menu.subMenu && menu.subMenu.length) {
  //           return (
  //             <React.Fragment key={uniqueId}>
  //               <Accordion
  //                 sx={{ width: "100%" }}
  //                 onClick={() => MobileOpenUserMenu(menu)}
  //               >
  //                 <AccordionSummary
  //                   aria-controls="panel1d-content"
  //                   id="panel1d-header"
  //                   expandIcon={menu.icon}
  //                 >
  //                   <Box
  //                     className="d-flex justify-content-between"
  //                     sx={{ width: "100%" }}
  //                   >
  //                     <Typography
  //                       sx={{ marginLeft: "10px" }}
  //                     >
  //                       {menu.title}
  //                     </Typography>
  //                     <AddIcon />
  //                   </Box>
  //                 </AccordionSummary>
  //                 <AccordionDetails sx={{ padding: 0 }}>
  //                   {dropDown?.subMenu?.map((subMenu) => {
  //                     const secondSunNavId = "secondSubNav" + i
  //                     return <AccordionSummary
  //                       expandIcon={subMenu.icon}
  //                       onClick={() => Routing(subMenu)}
  //                       key={secondSunNavId}
  //                     >
  //                       <Typography
  //                         sx={{ marginLeft: "10px" }}
  //                       >
  //                         {subMenu.title}
  //                       </Typography>
  //                     </AccordionSummary>
  //                   })}
  //                 </AccordionDetails>
  //               </Accordion>
  //             </React.Fragment>
  //           );
  //         } else {
  //           return (
  //             <Accordion
  //               sx={{ width: "100%" }}
  //               onClick={() => Routing(menu)}
  //               key={uniqueId}
  //             >
  //               <AccordionSummary expandIcon={menu.icon}>
  //                 <Typography sx={{ marginLeft: "10px" }}>
  //                   {menu.title}
  //                 </Typography>
  //               </AccordionSummary>
  //             </Accordion>
  //           );
  //         }
  //       })}
  //       <Accordion
  //         sx={{
  //           width: "100%",
  //           backgroundColor: "#313949",
  //           color: "white",
  //         }}
  //       >
  //         <AccordionSummary expandIcon={false}>
  //           <Typography
  //             sx={{ width: "100%" }}
  //             textAlign={"center"}
  //             onClick={() => navigate("/login")}
  //           >
  //             Log out
  //           </Typography>
  //         </AccordionSummary>
  //       </Accordion>
  //     </Box>
  //   </Drawer>
  // </Box>
}
